import * as amplitude from "@amplitude/analytics-browser";
import { SHARED_EVENTS_PARAMS } from "@app/dashboard/constants/tracking_events/shared";
import {
  SYSTEM_EVENTS,
  SYSTEM_EVENTS_PARAMS,
  SYSTEM_EVENTS_VALUES
} from "@app/dashboard/constants/tracking_events/system";
import { getCurrentPath } from "../getCurrentPath";
import { toUpperSnakeCase } from "../toUpperSnakeCase";


export const onToasterShowHandler = ({
  type,
  trackingCode,
  msg,
  srcFeature
}: {
  type?: "success" | "error" | "warning" | null,
  trackingCode?: string,
  msg: string,
  srcFeature: string
}) => {

  const tracking_code = type === 'error' ?
    `${trackingCode}_FAILED`
    :
    type === 'success' ?
      `${trackingCode}_SUCCEEDED`
      :
      trackingCode;

  amplitude.track(SYSTEM_EVENTS.TOAST_SHOWN, {
    [SYSTEM_EVENTS_PARAMS.TOAST_TYPE]: SYSTEM_EVENTS_VALUES.TOAST_TYPE(type),
    [SYSTEM_EVENTS_PARAMS.TOAST_CODE]: trackingCode ? tracking_code : toUpperSnakeCase(msg),
    [SYSTEM_EVENTS_PARAMS.MESSAGE]: msg,
    [SYSTEM_EVENTS_PARAMS.SRC_FEATURE]: srcFeature,
    [SHARED_EVENTS_PARAMS.FROM_PAGE]: getCurrentPath(),
  });
};